module.exports = __webpack_public_path__ + "img/ic_check_mint.77ff94ce.svg";